import {Component, EventEmitter, Input, Output, TemplateRef, ChangeDetectionStrategy} from '@angular/core';
import lodash, {Dictionary} from "lodash";

@Component({
    selector: 'app-shared-chart-legend',
    templateUrl: './shared-chart-legend.component.html',
    styleUrls: ['./shared-chart-legend.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SharedChartLegendComponent {
  legendData: Dictionary<SerieConfig>;
  content: TemplateRef<any>;
  @Input() collapsible: boolean;
  @Output() hiddenLabelsOutput: EventEmitter<string[]> = new EventEmitter<string[]>();
  @Output() legendDataChange: EventEmitter<SerieConfig[]> = new EventEmitter<SerieConfig[]>();

  @Input("legendData")
  set setLegendData(series: SerieConfig[]) {
    this.legendData = lodash.keyBy(series, "name");
  }

  protected get hiddenLabels(): string[] {
    return Object.values(this.legendData).filter(s => !s.selected).map(s => s.name);
  }

  getAllLabels = (): string[] => {
    return lodash.sortBy(Object.keys(this.legendData), v => v);
  }

  getDatasetColor = (label: string): string => {
    return this.legendData[label]?.color;
  }

  toggleVisibility = (label: string) => {
    this.setVisibility(label, !this.hiddenLabels.includes(label));
  }

  private setVisibility(label: string, isHidden: boolean) {
    this.legendData[label].selected = !isHidden;
    this.legendDataChange.next(Object.values(this.legendData));
  }

  toggleSelect(): void {
    const allLabels = this.getAllLabels();
    const hidden = allLabels.length !== this.hiddenLabels.length;
    const labelsToToggle = hidden
      ? allLabels.filter(l => !this.hiddenLabels.includes(l))
      : allLabels.filter(l => this.hiddenLabels.includes(l));
    labelsToToggle.forEach(l => this.setVisibility(l, hidden));
  }

  get selectText(): string {
    const allLabels = this.getAllLabels();
    return allLabels.length === this.hiddenLabels.length ? "Select all" : "Deselect all";
  }
}

export interface SerieConfig {
  name: string;
  selected: boolean;
  color: string;
}
